import { getAllData } from 'apis/customApiHandler';
import useDebounce from 'hooks/useDebounce';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Button, Input } from 'styled';
import { TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Add from './Add';
import ViewList from './ViewList';

const Index = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  const currentUser = useSelector((state) => state.user.currentUser);
  const debouncedValue = useDebounce(search, 1000);
  const { data } = useQuery(
    ['tyre-replacement-reason', debouncedValue && debouncedValue],
    () =>
      getAllData('/tyre-replacement-reason', {
        searchQuery: debouncedValue,
      })
  );

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <Button
            className="!px-8 disabled:bg-gray-400"
            onClick={() => setShowAddmodel(true)}
            bgPrimary
            disabled={
              !checkPermission([permissions.manage_masters], currentUser)
            }
          >
            Add
          </Button>
        </div>
      </div>
      <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Replacement Reason Name</TH>
                    <TH scope="col">Created At</TH>
                    <TH scope="col">Actions</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data?.data &&
                    data?.data.map((d, index) => (
                      <ViewList data={d} key={d._id} index={index} />
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {showAddmodel && <Add handleClick={() => setShowAddmodel(false)} />}
    </div>
  );
};

export default Index;
